export default __webpack_public_path__ + "static/media/descF2P.1dccae57.svg";